export const TID = {
  // App shell
  shellBrand: "shell-brand",
  navUpload: "nav-upload",
  navQueue: "nav-queue",
  navVendorDesk: "nav-vendor-desk",
  navSentToEc: "nav-sent-to-ec",
  // Legacy alias — keep until all test selectors migrate.
  navConfirmed: "nav-sent-to-ec",

  // Upload page
  uploadDropzone: "upload-dropzone",
  uploadFileInput: "upload-file-input",
  uploadFileRow: (i) => `upload-file-row-${i}`,
  uploadFileRemove: (i) => `upload-file-remove-${i}`,
  uploadClearAll: "upload-clear-all",
  uploadStart: "upload-start-batch",
  uploadNotes: "upload-notes",

  // Batch processing
  batchSummaryTotal: "batch-summary-total",
  batchSummaryProcessing: "batch-summary-processing",
  batchSummaryReady: "batch-summary-ready",
  batchSummaryNeedsReview: "batch-summary-needs-review",
  batchSummaryBlocked: "batch-summary-blocked",
  batchSummaryFailed: "batch-summary-failed",
  batchRefresh: "batch-refresh",
  batchGoToQueue: "batch-go-to-queue",

  // Candidate queue
  queueTab: (s) => `queue-tab-${s}`,
  queueRow: (id) => `queue-row-${id}`,
  queueReviewBtn: (id) => `queue-review-${id}`,
  queueSearch: "queue-search",
  queueBatchFilter: "queue-batch-filter",

  // Candidate review
  reviewStatusBanner: "review-status-banner",
  reviewAttachment: "review-attachment",
  reviewVendorPanel: "review-vendor-panel",
  reviewVendorAccept: "review-vendor-accept",
  reviewVendorSearch: "review-vendor-search",
  reviewVendorCreate: "review-vendor-create-open",
  reviewVendorCreateName: "review-vendor-create-name",
  reviewVendorCreateGst: "review-vendor-create-gst",
  reviewVendorCreatePan: "review-vendor-create-pan",
  reviewVendorCreateVatTin: "review-vendor-create-vat-tin",
  reviewVendorCreateJurisdiction: "review-vendor-create-jurisdiction",
  reviewVendorIdentityPanel: "review-vendor-identity-panel",
  reviewVendorIdentityStrength: "review-vendor-identity-strength",
  reviewVendorIdentityConflict: "review-vendor-identity-conflict",
  reviewVendorIdentityGstin: "review-vendor-identity-gstin",
  reviewVendorIdentityPan: "review-vendor-identity-pan",
  reviewVendorIdentityVatTin: "review-vendor-identity-vat-tin",
  reviewVendorIdentityJurisdiction: "review-vendor-identity-jurisdiction",
  reviewVendorIdentitySave: "review-vendor-identity-save",
  reviewVendorCreateCategory: "review-vendor-create-category",
  reviewVendorCreateSubmit: "review-vendor-create-submit",
  reviewVendorSelect: (id) => `review-vendor-select-${id}`,
  reviewBillNumber: "review-bill-number",
  reviewBillDate: "review-bill-date",
  reviewSubtotal: "review-subtotal",
  reviewTaxTotal: "review-tax-total",
  reviewTotalAmount: "review-total-amount",
  reviewAddLine: "review-add-line",
  reviewLineRow: (i) => `review-line-row-${i}`,
  reviewLineName: (i) => `review-line-name-${i}`,
  reviewLineQty: (i) => `review-line-qty-${i}`,
  reviewLineUnit: (i) => `review-line-unit-${i}`,
  reviewLineUnitPrice: (i) => `review-line-unit-price-${i}`,
  reviewLineTaxPct: (i) => `review-line-tax-${i}`,
  reviewLineTotal: (i) => `review-line-total-${i}`,
  reviewLineRemove: (i) => `review-line-remove-${i}`,
  reviewSave: "review-save",
  reviewSendToEc: "review-send-to-ec",
  // Legacy alias — same DOM node, kept for test back-compat.
  reviewConfirm: "review-send-to-ec",
  reviewReject: "review-reject-open",
  reviewRejectReason: "review-reject-reason",
  reviewRejectSubmit: "review-reject-submit",
  reviewRetryOcr: "review-retry-ocr",
  reviewExtractMissing: "review-extract-missing",
  reviewExtractMissingBanner: "review-extract-missing-banner",

  // Sent-to-EC view
  sentToEcRow: (id) => `sent-to-ec-row-${id}`,
  // Legacy alias
  confirmedRow: (id) => `sent-to-ec-row-${id}`,

  // Vendor desk
  vendorDeskApply: "vendor-desk-apply",

  // Validation Dashboard
  navValidation: "nav-validation",
  validationPage: "validation-page",
  validationRangeToday: "validation-range-today",
  validationRange7d: "validation-range-7d",
  validationRange30d: "validation-range-30d",
  validationRangeCustom: "validation-range-custom",
  validationFromDate: "validation-from-date",
  validationToDate: "validation-to-date",
  validationOutletSelect: "validation-outlet-select",
  validationOutletAll: "validation-outlet-all",
  validationOutletOption: (id) => `validation-outlet-${id}`,
  validationExportCsv: "validation-export-csv",
  validationRefresh: "validation-refresh",
  validationMetric: (k) => `validation-metric-${k}`,
  validationDrilldownTab: (k) => `validation-drilldown-tab-${k}`,
  validationDrilldownRow: (id) => `validation-drilldown-row-${id}`,
};
